<template>
  <BaseInput
    v-uppercase="capitalise"
    :class="inputClass"
    autocomplete="off"
  >
    <template #action>
      <button
        v-if="clearable"
        type="button"
        data-nui-tooltip="Save"
        class="absolute right-0 top-1 float-right mr-2 mt-2"
        @click="$emit('update:modelValue', '')"
      >
        <Icon name="lucide:x" class="size-4" />
      </button>
    </template>
  </BaseInput>
</template>

<script setup lang="ts">
defineProps({
  clearable: { type: Boolean, default: false },
  inputClass: { type: String, default: '' },

})
const { $dataService } = useNuxtApp()
let capitalise = false

try {
  capitalise = (await $dataService.getBrowserDbSettings()).capitalise
}
catch (error) {
  console.warn('BaseInputCaps: failed to load browser DB settings, continuing with defaults', error)
}
</script>
